import router from '@/routes'
import storage from '@/utils/storage'
import store from '@/store'
import Axios from 'axios'
import BookingApi from '../core/api'
import { isEqual, difference, clone } from '@/utils/helpers'

var loadingBookings = false;
var initData = false;
var ajaxRequest = null;

const state = {
  clients: [],
  destinations: [],
  insurances: [],
  drivers: [],
  bookings: [],
  oldData: [],
  diffData: [],
  timelineBookings: []
}

const actions = {
  getDrivers ({commit}) {
    var that = this;
    return new Promise((resolve, reject) => {
      that._vm.$http
      .get('service/driver/active')
      .then(response => {
        if (response) {
          commit('SET_drivers', response.data);
          // console.log('drivers data', response.data);
          resolve(response.data);
        }
      })
      .catch(function (error) {
        console.log('catch:', error);
        reject(error);
      });
    })
  },
  getBookings ({commit}) {
    const that = this;

    return new Promise((resolve, reject) => {

      if (ajaxRequest) {
        ajaxRequest.cancel();
        console.log('ajaxRequest cancel:', ajaxRequest);
      }

      if (state.loadingBookings) {
        state.loadingBookings = false;
        console.log('bookings already loading ... RESET loadingBookings', state.loadingBookings);
        reject(null);
      } else {

        state.loadingBookings = true;
        console.log('SET loadingBookings:', state.loadingBookings);
        ajaxRequest = Axios.CancelToken.source();

        BookingApi('service/booking/timeline', {
          method: 'GET',
          timeout: 15000,
          data: { cancelToken: ajaxRequest.token }
        })
        .then(response => {
          console.log('1 ---- getBookings GET response');
          var refresh = commit('SET_bookings', response.data);
          resolve (refresh);
        })
        .catch((error) => {
          if (Axios.isCancel(error)) {
            console.log('Previous request canceled, new request is send', error.message);
         } else {
            console.log('0 ---- getBookings catch:', error);
         }
         reject(null);
        })
        .then(() => {
          state.loadingBookings = false;
          console.log('2 ---- getBookings finally', state.loadingBookings);
        });
      }
    })
  },
  getCients ({commit}) {
    var that = this;
    return new Promise((resolve, reject) => {
      that._vm.$http
      .get('api/client')
      .then(response => {
        state.clients = response.data;
        resolve(state.clients);
      })
      .catch(function (error) {
        reject(error);
      });
    });
  },
  getDestinations ({commit}) {
    var that = this;
    return new Promise((resolve, reject) => {
      that._vm.$http
      .get('api/destination')
      .then(response => {
        state.destinations = response.data;
        resolve(state.destinations);
      })
      .catch(function (error) {
        reject(error);
      });
    });
  },
  getInsurances ({commit}) {
    var that = this;
    return new Promise((resolve, reject) => {
      that._vm.$http
      .get('api/insurance')
      .then(response => {
        state.insurances = response.data;
        resolve(state.insurances);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }
}

const mutations = {
  SET_drivers (state, data) {
    state.drivers = data;
  },
  SET_bookings (state, data) {
    var that = this;
    if (state.initData) {
      var diffData = difference(data, state.oldData);
      diffData.forEach((item) => {
        if (item && item.accepted > 1) {
          const snd = (item.accepted >= 3) ? ((item.accepted === 3) ? 'not' : 'time') : 'ok';
          store.commit('playSound', snd);
        }
      })
    }
    state.oldData = data;
    state.bookings = clone(data);
    state.initData = true;
    state.loadingBookings = false;
    return diffData;
  },
  SET_timelineBookings (state, data) {
    state.timelineBookings = data;
  },
  CLEAR_loadingsBookings() {
    state.loadingBookings = false;
    console.log('CLEAR loadingBookings:', state.loadingBookings);
  }
}

const getters = {
  bookings: (state) => {
    return state.bookings;
  },
  timelineBookings () {
    return state.timelineBookings;
  },
  oldData: (state) => {
    return state.oldData;
  },
  drivers: (state) => {
    return state.drivers;
  },
  clients: (state) => {
    return state.bookings;
  },
  destinations: (state) => {
    return state.drivers;
  },
  insurances: (state) => {
    return state.drivers;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
